/**
 * Main Accessibility Provider
 * Orchestrates accessibility contexts and provides unified API
 */

import React from 'react';
import { FocusManagementProvider } from './FocusManagementProvider';
import { ScreenReaderProvider } from './ScreenReaderProvider';
import { ColorContrastProvider } from './ColorContrastProvider';
import { KeyboardNavigationProvider } from './KeyboardNavigationProvider';

interface AccessibilityProviderProps {
  children: React.ReactNode;
}

export const AccessibilityProvider: React.FC<AccessibilityProviderProps> = ({ children }) => {
  return (
    <KeyboardNavigationProvider>
      <ScreenReaderProvider>
        <FocusManagementProvider>
          <ColorContrastProvider>
            {children}
          </ColorContrastProvider>
        </FocusManagementProvider>
      </ScreenReaderProvider>
    </KeyboardNavigationProvider>
  );
};